"use client";

import { FormEvent, useState } from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const LoginForm = ({ noContainer }: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [send, setSend] = useState(false);
  const [email, setEmail] = useState<any>("");

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData(e.currentTarget);
    const data = {
      email: formData.get("email"),
    };

    setEmail(formData.get("email"));
    fetch(`${`/api/auth`}`, {
      method: "POST",
      body: JSON.stringify(data),
    })
      .then((response) => {
        setLoading(false);
        setSend(true);
      })
      .catch((error) => {
        setLoading(false);
        setSend(true);
      });
  }

  return (
    <div className="relative left-[-10px] my-12 h-fit w-screen bg-nsc-dark-blue px-[10px] py-12 text-white md:left-0 md:w-full md:rounded md:p-10 lg:p-16">
      {send ? (
        <div className="flex flex-col gap-4">
          <p className="body-xl text-white">
            U ontvangt een e-mail op het e-mailadres: {email} waarmee u kunt inloggen.
          </p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="">
          <div className="grid grid-cols-1 gap-6">
            <div className="grid w-full items-center gap-1.5">
              <Label htmlFor="email">E-mail*</Label>
              <Input className="text-nsc-dark-blue" required type="email" id="email" name="email" autoComplete="email" />
            </div>
            <div className="grid w-full items-center gap-1.5">
              <Button disabled={loading} type="submit" variant="default">
                {loading ? "Versturen..." : "Inloggen"}
              </Button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default LoginForm;
